import React, { createContext, useState } from "react";
import Validade from "../helpers/validate";
import GetCardType from "../helpers/creditCard";
import { checkCreditCard, checkExpiration } from "../helpers/creditCardValid";
import { SaveCard } from "../services/Api/card";
import { Encrypt } from "../services/Crypt";

export const PaymentContext = createContext({})

export default function PaymentProvider({ children }) {
    const [selectedPaymentForm, setSelectedPaymentForm] = useState(null);
    const [newCard, setNewCard] = useState(false);
    const [saveCard, setSaveCard] = useState(false);
    const [cardBrand, setCardBrand] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [cardName, setCardName] = useState("");
    const [cardDocument, setCardDocument] = useState("");
    const [cardExpiration, setCardExpiration] = useState("");
    const [cardCvv, setCardCvv] = useState("");
    const [validCardNumber, setValidCardNumber] = useState({
        isValid: true,
        invalidMessage: "Cartão válido",
    });
    const [validCardName, setValidCardName] = useState({
        isValid: true,
        invalidMessage: "Nome inválido",
    });
    const [validCardExpiration, setValidCardExpiration] = useState({
        isValid: true,
        invalidMessage: "Data inválida",
    });
    const [validCardCvv, setValidCardCvv] = useState({
        isValid: true,
        invalidMessage: "CVV inválido",
    });
    const [validCardDocument, setValidCardDocument] = useState({
        isValid: true,
        invalidMessage: "Documento inválido",
    });

    const saveCardApi = (cardBrandType) => {
        let salvo = false;
        SaveCard(
            cardName,
            cardDocument,
            Encrypt(cardNumber.replace(/\s/g, "")),
            cardExpiration,
            cardBrand ? cardBrand : cardBrandType
        )
            .then((value) => {
                salvo = true;
            })
            .catch((value) => {
                // setShowAlert({
                //     type: "alert",
                //     title: "Erro ao salvar o cartão",
                //     message: value.erro ? value.erro : "Não informado",
                //     show: true,
                //     confirmText: "OK",
                //     pressConfirm: () => {
                //         setShowAlert({ ...showAlert, show: false });
                //     },
                // });
            })
            .finally(() => {
                // setLoading({ show: false, message: "Salvando o cartão" });
            });
        return salvo;
    };

    const clearInput = () => {
        setCardNumber("")
        setCardName("")
        setCardDocument("")
        setCardExpiration("")
        setCardCvv("")
        setCardDocument("")
        setNewCard(false)
        setSaveCard(false)
        setSelectedPaymentForm(null)
      }

    const validNewCard = () => {
        let valid = true;
        let cardBrandType = GetCardType(cardNumber.replace(/\s/g, ""));
        setCardBrand(cardBrandType);
        let checkNumber = checkCreditCard(cardNumber, cardBrandType);

        //Card number
        if (!checkNumber.valid) {
            valid = false;
            setValidCardNumber({
                isValid: checkNumber.valid,
                invalidMessage: checkNumber.message,
            });
        } else {
            setValidCardNumber({ ...validCardNumber, isValid: true });
        }
        //Card Name
        if (cardName == "") {
            valid = false;
            setValidCardName({ ...validCardName, isValid: false });
        } else setValidCardName({ ...validCardName, isValid: true });
        //Card Expiration
        if (checkExpiration(cardExpiration)) {
            valid = false;
            setValidCardExpiration({ ...validCardExpiration, isValid: false });
        } else setValidCardExpiration({ ...validCardExpiration, isValid: true });
        if ((!Validade.validDocument(cardDocument))) {
            valid = false;
            setValidCardDocument({ ...validCardDocument, isValid: false });
        } else setValidCardDocument({ ...validCardDocument, isValid: true });
        return valid;
    };

    return <PaymentContext.Provider value={{
        selectedPaymentForm, setSelectedPaymentForm,
        newCard, setNewCard,
        saveCard, setSaveCard,
        saveCardApi, validNewCard,
        validCardNumber, validCardName, validCardExpiration, validCardCvv, validCardDocument,
        cardNumber, cardName, cardDocument, cardExpiration, cardCvv, 
        setCardNumber, setCardName, setCardDocument, setCardExpiration, setCardCvv,
        clearInput
    }}>
        {children}
    </PaymentContext.Provider>
}